const SET_NEW_PRODUCTS_PAGE = 'SET_NEW_PRODUCTS_PAGE';
const SET_BESTSELLER_PRODUCTS_PAGE = 'SET_BESTSELLER_PRODUCTS_PAGE';

export {
    SET_NEW_PRODUCTS_PAGE, SET_BESTSELLER_PRODUCTS_PAGE
};
